import { label, labelBold, labelWithIndicator, statusIndicator } from './label.css';
import clsx from 'clsx';

export const labelVariants = new Set(label.variants());
export * from './label.css';

export interface NoStatusLabelProps {
	color?:
		| 'red'
		| 'raspberry'
		| 'clementine'
		| 'yellow'
		| 'green'
		| 'teal'
		| 'blue'
		| 'plum'
		| 'purple'
		| 'grey'
		| 'outline';
	bold?: boolean;
	showStatusIndicator?: false;
}

export interface StatusLabelProps {
	color?: 'red' | 'yellow' | 'green' | 'grey';
	bold?: true;
	showStatusIndicator: true;
}

export type BaseLabelProps = NoStatusLabelProps | StatusLabelProps;

const colorsWithStatusIndicator = new Set(['red', 'yellow', 'green', 'grey']);

export function assertLabelProps(props: Partial<BaseLabelProps>) {
	if (props.showStatusIndicator === true) {
		if (!colorsWithStatusIndicator.has(props.color ?? 'grey')) {
			throw new Error(`Status indicator not available for color "${props.color}"`);
		}

		if ((props.bold as boolean | undefined) === false) {
			throw new Error(`Status indicator only available for bold labels`);
		}
	}
}

export function labelClassName(props: Partial<BaseLabelProps>) {
	const { color, bold, showStatusIndicator } = props;

	const classes = [label({color})];

	if (bold ?? true) {
		classes.push(labelBold);
	}

	if (showStatusIndicator ?? false) {
		classes.push(labelWithIndicator);
	}

	return clsx(classes);
}

export function statusIndicatorClassName(props: Partial<BaseLabelProps>) {
	const { color } = props;

	return statusIndicator({ color: color as StatusLabelProps['color'] });
}
